// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSkeleton_container__rUGXF","shimmer":"LoadingSkeleton_shimmer__1N-_0"};